module.exports = __webpack_public_path__ + "img/b-mask_indian-guy.6ab510d.png";